/**
 * Component to initialize the navigation service with the router's navigate function.
 * Must be rendered inside RouterProvider to access useNavigate.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigate } from './navigationService';

export const NavigationSetter: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return null;
};
